import { render, staticRenderFns } from "./DeviceCardImage.vue?vue&type=template&id=a7a681b6&scoped=true&"
import script from "./DeviceCardImage.vue?vue&type=script&lang=js&"
export * from "./DeviceCardImage.vue?vue&type=script&lang=js&"
import style0 from "./DeviceCardImage.vue?vue&type=style&index=0&id=a7a681b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a681b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
